import { useLenis } from "../hooks/useLenis";
import { Navbar } from "../components/site/Navbar";
import { Hero } from "../components/site/Hero";
import { Ribbon } from "../components/site/Ribbon";
import { Manifesto } from "../components/site/Manifesto";
import { Vision } from "../components/site/Vision";
import { Product } from "../components/site/Product";
import { Downloads } from "../components/site/Downloads";
import { Infrastructure } from "../components/site/Infrastructure";
import { Quality } from "../components/site/Quality";
import { Values } from "../components/site/Values";
import { Enquiry } from "../components/site/Enquiry";
import { Contact } from "../components/site/Contact";
import { WhatsAppButton } from "../components/site/WhatsAppButton";
import { Toaster } from "../components/ui/sonner";

export default function Home() {
  useLenis();
  return (
    <div className="App relative" data-testid="home-page">
      <Navbar />
      <Hero />
      <Ribbon />
      <Manifesto />
      <Vision />
      <Product />
      <Downloads />
      <Ribbon dark />
      <Infrastructure />
      <Quality />
      <Values />
      <Enquiry />
      <Contact />
      <WhatsAppButton />
      <Toaster position="top-center" richColors />
    </div>
  );
}
